import React, { useContext, useEffect, useMemo, useState } from "react";

import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { DatabaseContext, UserContext } from "../../../context";
import ProjectAudioFileComponent from "./File Types/ProjectAudioFileComponent";
import ProjectImageFileComponent from "./File Types/ProjectImageFileComponent";
import ProjectPDFFileComponent from "./File Types/ProjectPDFFileComponent";
import ProjectVideoFileComponent from "./File Types/ProjectVideoFileComponent";
import ProjectComponentFrame from "./ProjectComponentFrame";

export default function ProjectFileComponent(props) {
    const { currentUserData } = useContext(UserContext);
    const { files = [], filesLoaded = false } = useContext(DatabaseContext);
    const [isEditing, setIsEditing] = useState(false);
    const [contentWidth, setContentWidth] = useState(900);
    const file = useMemo(
        () =>
            files.find((item) => item.key === props.component?.linkKey),
        [files, props.component?.linkKey],
    );

    useEffect(() => {
        if (currentUserData && props.component) {
            setIsEditing(props.isEditing);
        }
    }, [currentUserData, props.component, props.isEditing]);

    useEffect(() => {
        function handleResize() {
            setContentWidth(
                Math.max(280, Math.min(window.innerWidth - 96, 900)),
            );
        }

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const fileType = props.component?.fileType || "";

    return (
        <ProjectComponentFrame
            component={props.component}
            isEditing={isEditing}
            label="Resource"
            onDelete={() => props.delete(props.component)}
            onMoveUp={() => props.moveUp(props.component)}
            onMoveDown={() => props.moveDown(props.component)}
        >
            {!filesLoaded && !file ? (
                <Box
                    sx={{
                        minHeight: 160,
                        display: "grid",
                        placeItems: "center",
                        color: "text.secondary",
                    }}
                >
                    <Box sx={{ textAlign: "center" }}>
                        <CircularProgress size={28} />
                        <Typography variant="body2" sx={{ mt: 1.25 }}>
                            Loading resource…
                        </Typography>
                    </Box>
                </Box>
            ) : !file ? (
                <Box
                    sx={{
                        minHeight: 140,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "text.secondary",
                        textAlign: "center",
                    }}
                >
                    <InsertDriveFileOutlinedIcon
                        sx={{ fontSize: 40, opacity: 0.42 }}
                    />
                    <Typography variant="subtitle2" sx={{ mt: 1 }}>
                        This resource is no longer available
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ width: "100%", overflow: "hidden" }}>
                    {fileType.includes("video") && (
                        <ProjectVideoFileComponent
                            file={file}
                            contentWidth={contentWidth}
                        />
                    )}
                    {fileType.includes("image") && (
                        <ProjectImageFileComponent
                            file={file}
                            contentWidth={contentWidth}
                        />
                    )}
                    {fileType.includes("audio") && (
                        <ProjectAudioFileComponent
                            file={file}
                            contentWidth={contentWidth}
                        />
                    )}
                    {fileType === "application/pdf" && (
                        <ProjectPDFFileComponent
                            file={file}
                            contentWidth={contentWidth}
                        />
                    )}
                </Box>
            )}
        </ProjectComponentFrame>
    );
}
